import { localStorageSelectiveClean } from "../../../../utils/localStorageSelectiveClean";

import cookie from "js-cookie";
import { cache as swrCache } from "swr";
import { BONUSX_ACCESS_TOKEN } from "../../../../common/env";
import mixpanel from "../../../../common/mixpanel-config";
import type { IJWTUserPayload } from "../../../../interfaces/JWTUserPayload";
import { accessTokenSubject$ } from "../../stores/access-token/access-token.store";
import type { ILocalAuthenticationStorageDataSource } from "./local-authentication-storage.datasource.interface";

export class LocalAuthenticationStorageDataSource implements ILocalAuthenticationStorageDataSource {
  private readonly _COOKIE_DEFAULT_DOMAIN = new URL(window.location.href).hostname;

  resetAuthenticationStorage(): void {
    localStorageSelectiveClean();
    swrCache.clear();
    cookie.remove(BONUSX_ACCESS_TOKEN, { path: "/", domain: `.${this._COOKIE_DEFAULT_DOMAIN}` });
    mixpanel.reset();
  }

  emitAuthenticationTokenStore(accessToken?: IJWTUserPayload): void {
    accessTokenSubject$.next(accessToken);
  }
}
